export default __webpack_public_path__ + "static/orangeloop-27-bfaa545ce935cdd633ec9fa3e18b74b8.jpg";